import {ELEMENT} from '../base/ElementTypes';
import {IElementQuestionnaire} from '../base/questionElementBase';

export enum MatchPairQuestionMode {
    LINES = 'lines',
    CARDS = 'cards',
}

export interface IElementQuestionMatchPair extends IElementQuestionnaire {
    type: ELEMENT.MATCH_PAIR_QUESTION;
    leftElement: IMatchPairQuestion[];
    rightElement: IMatchPairQuestion[];
    pairs: {leftElementId: string; rightElementId: string}[];
    answerTextAlign?: string;
    matchPairMode?: MatchPairQuestionMode;
    selectedColor?: string;
}

export interface IMatchPairQuestion {
    id: string;
    text: string;
}
